import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getSummary (params) {
    return request.get(API.EMPLOYEE_DASHBOARD_SUMMARY, params)
  },
  getRankingUser (params) {
    return request.get(API.EMPLOYEE_RANKING_USER, params)
  },
  getRankingFile (params) {
    return request.get(API.EMPLOYEE_RANKING_FILE, params)
  },
  getNewFile (params) {
    return request.get(API.EMPLOYEE_NEW_FILE, params)
  },
  getNotification (params) {
    return request.get(API.EMPLOYEE_NOTI, params)
  },
  updateNotification (params) {
    return request.put(API.EMPLOYEE_UPDATE_NOTI + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/employee/dashboard.js